import * as React from 'react';
import * as Scroll from 'react-scroll';

const { Link } = Scroll;


export default function Nav() {
    return (
        <nav className="nav">
            <div className="nav-content">
                <header className="nav-logo" onClick={() => Scroll.animateScroll.scrollToTop()}>
                    Nesjartun Camping
                    </header>
                <ul className="nav-items">
                    <li className="nav-item"><Link activeClass="active" to="about" spy={true} smooth={true} offset={-80} duration={500}>Om plassen</Link></li>
                    <li className="nav-item"><Link activeClass="active" to="cabins" spy={true} smooth={true} offset={-80} duration={500}>Hytter</Link></li>
                    <li className="nav-item"><Link activeClass="active" to="camping" spy={true} smooth={true} offset={-80} duration={500}>Telt, bil og vogn</Link></li>
                    <li className="nav-item"><Link activeClass="active" to="boats" spy={true} smooth={true} offset={-80} duration={500}>Båtutleige</Link></li>
                    <li className="nav-item"><Link activeClass="active" to="fishing" spy={true} smooth={true} offset={-80} duration={500}>Fiske</Link></li>
                </ul>
            </div>
        </nav>
    );
}